// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FileMessagePreview_root__oAIcV {
  line-height: 0;
  color: #8E8E93;
  position: relative;
  bottom: 2px;
}

.FileMessagePreview_icon__hnESC {
  margin-right: -1px;
  position: relative;
  top: 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/messagePreviews/FileMessagePreview/FileMessagePreview.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;AACF","sourcesContent":[".root {\n  line-height: 0;\n  color: #8E8E93;\n  position: relative;\n  bottom: 2px;\n}\n\n.icon {\n  margin-right: -1px;\n  position: relative;\n  top: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `FileMessagePreview_root__oAIcV`,
	"icon": `FileMessagePreview_icon__hnESC`
};
export default ___CSS_LOADER_EXPORT___;
